<template>
    <div class="position-absolute w-100 h-100 d-flex">
        <b-card no-body class="m-3 flex-grow-1">
            <b-tabs pills card :vertical="!isMediumScreen">
                <b-tab title="Denuncia compliance" active>
                    <b-card-text>
                        <button class="btn btn-sm btn-outline-secondary" @click="$router.push({ name: 'Login' })">
                            Volver a compliance
                        </button>
                        <hr>
                        <div class="denounce-parent-container">
                            <AlertDismiss class="me-3 alert-sticky" ref="alertDismiss" />
                            <DenounceForm @alert="showAlert" class="me-3"/>
                        </div>
                    </b-card-text>
                </b-tab>
                <b-tab title="Denuncia Ley Karin">
                    <div>
                        <button class="btn btn-sm btn-outline-secondary" @click="$router.push({ name: 'Login' })">
                            Volver a compliance
                        </button>
                        <div class="card mt-2">
                            <div class="card-body pt-2">
                                <KarinForm :anonymous="true"></KarinForm>
                            </div>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
import DenounceForm from '@/components/Denounce/DenounceMenu/Denounce-form.vue';
import { EventNames, InitPageSize } from '@/plugins/enums/index.js'
import { mapActions } from 'vuex';
import KarinForm from '@/components/KarinLaw/KarinMenu/Karin-form.vue';
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';

export default {
    name: 'DenounceAnonymousViews',

    components: {
        KarinForm,
        DenounceForm,
        AlertDismiss
    },

    data() {
        return {
            windowWidth: window.innerWidth,
            noProgress: true,
            isUploadingForm: false,

            modalShowCrear: false,
            modalShowNotificar: false,
            denounceAccuser: true,
            denounceQuestions: false,
            denounceFile: false,
            denuncia: {
                accuserId: null,
                answers: [],
                route: null
            },
            filter: {
                page: 1,
                pageSize: InitPageSize.DenouncePageSize
            }
        }
    },

    created() {
        window.addEventListener('resize', this.onResize)
    },

    async mounted() {
        this.$eventBus.$on(EventNames.AccuserSiquinete, (accuser) => {
            this.denounceAccuser = false;
            this.denounceQuestions = true;
            this.denounceFile = false;
            this.denuncia.accuserId = accuser?.id;
            this.$refs.progressCustom.progress(30, 'Denunciante seleccionado correctamente');
            this.noProgress = false
        });

        this.$eventBus.$on(EventNames.QuestionSiquinete, (questions) => {
            this.denounceAccuser = false;
            this.denounceQuestions = false;
            this.denounceFile = true;
            this.$refs.progressCustom.progress(80, 'Respuestas registradas correctamente');
            this.denuncia.answers = questions.map((q) => {
                return {
                    questionId: q.id,
                    answerValue: q.respuesta
                }
            })
        });

        this.$eventBus.$on(EventNames.FileSiquinete, async (route) => {
            this.denounceAccuser = false;
            this.denounceQuestions = false;
            this.denounceFile = true;
            this.$refs.progressCustom.progress(90, 'documento subido correctamente');
            this.denuncia.route = route;
            await this.crearDenuncia();
        });
    },

    beforeDestroy() {
        window.removeEventListener('resize', this.onResize)
    },

    methods: {
        ...mapActions(["anonCreateDenunciation"]),

        onResize() {
            this.windowWidth = window.innerWidth
        },

        onModalHide() {
            this.clear();
        },

        clear() {
            this.denounceAccuser = true;
            this.denounceQuestions = false;
            this.denounceFile = false;
            this.denuncia.accuserId = null;
            this.denuncia.answers = [];
            this.denuncia.route = null;
            this.noProgress = true;
        },

        async crearDenuncia() {
            this.isUploadingForm = true;
            let result = await this.anonCreateDenunciation(this.denuncia);

            if (result.isError) {
                this.$refs.alertDismiss.showAlert(result.message);
                this.$refs.progressCustom.progress(0, 'error');
                this.isUploadingForm = false;
                return;
            }

            this.$eventBus.$emit(EventNames.CreateDenunciation, this.filter);
            this.$refs.alertDismiss.showAlert('Denuncia creada correctamente', 'success');
            this.$refs.progressCustom.progress(100, 'denuncia creada correctamente');
            this.isUploadingForm = false;

            setTimeout(() => {
                this.clear();
                this.$refs.progressCustom.progress(0, '');
            }, 2000);
        },

        showAlert(message, type) {
            this.$refs.alertDismiss.showAlert(message, type);
        }
    },

    computed: {
        isMediumScreen() {
            return this.windowWidth < 768;
        },
    }
}
</script>

<style scoped>
hr {
    margin: 1em 0em 1em 0em;
}
 .denounce-parent-container {
    max-height: 80vh;
    overflow: auto;
    position: relative;
 }
 
 .alert-sticky {
    position: sticky;
    top: 0;
    z-index: 100;
 }
 </style>